import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { GRUPPER, GRUPPE_ICONS, DEFAULT_GRUPPE, isGruppe } from './grupper'

// The class picker in the top header on /andre-kjoretoy (#982), in place of
// Alle/Personbil/Varebil. The URL holds the class, so the header and the page
// read the same value and a reload keeps it.
export default function KlasseToggle() {
  const { t } = useTranslation('andreKjoretoy')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const segment = pathname.split('/')[2]
  const active = isGruppe(segment) ? segment : DEFAULT_GRUPPE

  return (
    <div role="group" aria-label={t('klasser.label')}
      className="flex rounded-lg border border-gray-200 dark:border-dark-border overflow-hidden">
      {GRUPPER.map((gruppe, i) => {
        const Icon = GRUPPE_ICONS[gruppe]
        const isActive = gruppe === active
        return (
          <button
            key={gruppe}
            type="button"
            aria-pressed={isActive}
            onClick={() => navigate(`/andre-kjoretoy/${gruppe}`)}
            className={`px-2 py-1 text-[11px] font-medium transition-colors flex flex-col items-center gap-0.5
              ${isActive
                ? 'bg-primary-500 text-white'
                : 'bg-white dark:bg-dark-card text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-dark-border'}
              ${i > 0 ? 'border-l border-gray-200 dark:border-dark-border' : ''}`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{t(`klasser.${gruppe}`)}</span>
          </button>
        )
      })}
    </div>
  )
}
